<script lang="ts" module>
  import { css } from "@agapi/ui/panda/css";
  import type { SystemStyleObject } from "@agapi/ui/panda/types";
  import type { Snippet } from "svelte";

  export interface MiniCartProps {
    /** A Svelte snippet containing the checklist items. */
    children?: Snippet;
    /** Custom CSS styles for the component. */
    css?: SystemStyleObject;
  }
</script>

<script lang="ts">
  import { miniCartStyles } from "./minicart.styles";

  const { css: cssProp, children }: MiniCartProps = $props();
  const classes = miniCartStyles.raw();
</script>

<footer class={css(classes.footer, cssProp)}>
  {@render children?.()}
</footer>
